export default function Footer() {
  const goTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="bg-black text-white pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10 pb-16 border-b border-white/10">
          <div className="lg:col-span-7">
            <button
              onClick={goTop}
              data-testid="footer-logo"
              className="text-left inline-block"
            >
              <img
                src="/brand/logo.png"
                alt="MasterBathrooms"
                className="h-32 md:h-40 w-auto"
              />
            </button>
            <p className="mt-6 max-w-md text-[#C7C7C7] leading-relaxed">
              Renovatie met meesterschap — luxe badkamers, toiletten en
              inloopdouches op maat, voor particulieren en bedrijven. Eén
              aanspreekpunt, vakkundig uitgevoerd.
            </p>
          </div>

          <div className="lg:col-span-5 grid grid-cols-2 gap-8">
            <div>
              <div className="text-[10px] uppercase tracking-[0.28em] text-[#3D7AE0] font-bold">
                Navigatie
              </div>
              <ul className="mt-5 space-y-3 text-sm text-white">
                {[
                  ["diensten", "Diensten"],
                  ["voor-na", "Voor & Na"],
                  ["werkwijze", "Werkwijze"],
                  ["reviews", "Reviews"],
                  ["faq", "FAQ"],
                  ["contact", "Contact"],
                ].map(([id, label]) => (
                  <li key={id}>
                    <button
                      onClick={() =>
                        document
                          .getElementById(id)
                          ?.scrollIntoView({ behavior: "smooth" })
                      }
                      data-testid={`footer-link-${id}`}
                      className="hover:text-[#3D7AE0] transition-colors uppercase tracking-wide font-medium"
                    >
                      {label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.28em] text-[#3D7AE0] font-bold">
                Contact
              </div>
              <ul className="mt-5 space-y-3 text-sm text-[#C7C7C7]">
                <li>info@master-bathrooms.nl</li>
                <li>+31 6 87445044</li>
                <li>master-bathrooms.nl</li>
                <li>Heel Nederland</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[10px] text-[#8A8A8A] uppercase tracking-[0.22em] font-semibold">
          <div>© {year} Master-Bathrooms — Alle rechten voorbehouden.</div>
          <div className="text-[#3D7AE0]">
            Renovatie met meesterschap
          </div>
        </div>
      </div>
    </footer>
  );
}
